<template>
  <Slider/>
  <Partners/>
  <Categories/>
  <Education/>
  <Business/>
  <Learning/>
  <Footer/>
</template>

<script>
import Slider from "@/components/gvLearning/Slider";
import Partners from "@/components/gvLearning/Partners";
import Categories from "@/components/gvLearning/Categories";
import Education from "@/components/gvLearning/Education";
import Business from "@/components/gvLearning/Business";
import Learning from "@/components/gvLearning/Learning";
import Footer from "@/components/gvLearning/Footer";

export default {
  components: {Slider, Partners, Categories, Education, Business, Learning, Footer}
}
</script>

<style>
html, body {
  overflow-x: hidden !important;
}
</style>
